import { CustomerRole } from "../../../models/enums"

const getInitialValues = (storefrontData) => {
  return {
    customerData: {
      role: storefrontData?.customerData?.role || CustomerRole.PRIVATE
    }
  }
}

export default getInitialValues